import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import {lighten } from '@mui/material/styles';

const columns = [ 
    {
        field: 'id',
        headerName: "ID",
        flex: 1,
        editable: false,
        minWidth: 100,
        hide:true
    },
    {
        field: 'internal_po_number',
        headerName: 'PO',
        flex: 1,
        editable: false,
        minWidth: 200
    },
    {
        field: 'internal_sku',
        headerName: 'Internal SKU',
        flex: 1,
        editable: false,
        minWidth: 200
    }, 
    {
        field: 'external_sku',
        headerName: 'External SKU',
        flex: 1,
        editable: false,
        minWidth: 150
    }, 
    {
        field: 'internal_price',
        headerName: 'Internal Price',
        flex: 1,
        editable: false,
        minWidth: 100
    },
    {
        field: 'external_price',
        headerName: 'External Price',
        flex: 1,
        editable: false,
        minWidth: 100
    },
    {
        headerName: 'Quantity',
        field: "quantity",
        sortable: false,
        editable: false,
        minWidth: 100,
    },
    {
        headerName: 'KY',
        field: "kentucky",
        sortable: false,
        editable: false,
        minWidth: 100,
    },
    {
        headerName: 'PA',
        field: "pennsylvania",
        sortable: false,
        editable: false,
        minWidth: 100,
    },
    {
        headerName: "CANC",
        field: "cancelled",
        sortable: false,
        editable: false,
        minWidth: 100,
    },
    {
        headerName: "BO",
        field: "backordered",
        sortable: false,
        editable: false,
        minWidth: 100,
    },
    {
        headerName: "DISC",
        field: "discontinued",
        sortable: false,
        editable: false,
        minWidth: 100,
    }

]


function DetailsTable(props) {

    return(
        <Box className={props.isMobile ? "mobile-table-box" : "desktop-table-box"} style={{width:"100%"}}>
            <DataGrid
                style={{width:"100%"}}
                rows={props.items}
                className={props.isMobile ? "mobile-table" : "desktop-table"}
                columns={columns}
                rowsPerPageOption = {[25, 50, 100]}
                checkboxSelection = {false}
                getRowClassName={(params) => params.row.class}
                sortModel = {[{field:'id', sort: 'desc'}]}
            />
        </Box>   
    )


}

export default DetailsTable;